const label = (shortcode) =>
  shortcode.charAt(0).toUpperCase() + shortcode.slice(1);

const GREENHOUSE_APPLICATION_SHORTCODES = [
  'terrabis',
  'cgmllc',
  'connected',
  'curaleaf',
  'gtillc',
  'pharmacann',
  'vzlss',
  'acerage',
  'flowery'
];

export const greenhouseEventTypeInfo = Object.fromEntries(
  GREENHOUSE_APPLICATION_SHORTCODES.map((shortcode) => [
    `greenhouse-application-${shortcode}`,
    { label: label(shortcode) }
  ])
);
